import { createSelector } from 'reselect';
import {
  getFolders,
  getFoldersLaoding,
} from '../../../myArmyList/common/selector';
import { FolderView } from './view/FolderView';
import { FolderNewView } from './view/FolderNewView';

export const FolderNewPresenter = createSelector(
  [getFolders, getFoldersLaoding],
  (folders, folderIsLoading): FolderNewView => {
    return new FolderNewView({
      folders: folders.map(
        (item) => new FolderView({ id: item.id, name: item.name }),
      ),
      isLoading: folderIsLoading,
      canSubmit: !folderIsLoading,
    });
  },
);
